<script>
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import VueQRCodeComponent from 'vue-qrcode-component'
import moment from "moment";
import VueHtml2pdf from 'vue-html2pdf'

export default {
  mixins: [apibtoast, apigeneric],
  props: ["satdosyaId", "Tamamlandi", "PATStartup", "Personeller"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "99999",
        PageDataSize: "1",
      },
      Malzemeler: {},
      MalzemeSayisi: 0,
      Fiyatlar: [],
      FiyatSayisi: 0,
      ihale_usulu: "",
      FiyatlarArray: [],
      EnDusukFirmaToplam: "",
      uri: "data:application/vnd.ms-excel;base64,",
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function (s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p];
        });
      },
      Dosyaadi: "",
      IdareAdi: "",
      Teklifdegerlendirmeyontem: null,
      TableData: {},
      Firmalar: {},
      Malzeme: {},
      FormData: [],
      ToplamkazananFirma: "",
      okurumsabit: {},
      Dosya:  {},
      checkboxdisapled: true,
      Piyasaarastirmagorevliler: {},
      UygunGorulenFirmalarData: {},
      GununTarihi: moment(String(new Date())).format("DD.MM.YYYY")

    };
  },
  components: {
    Loader,
    VueQRCodeComponent,
    VueHtml2pdf
  },
  watch: {
    satdosyaId() {
      this.Get();
    },
    PATStartup() {
      this.Get()
    }
  },
  methods: {

    Get() {
      this.ActionsGet({
        Service: "okurumsabit",
        Page: this.Page
      }).then((res) => {
        this.okurumsabit = res.Data[0];
      });



      this.ActionsSingleGet({
        Service: "satdosya",
        Id: this.satdosyaId,
      }).then((res) => {
        this.Dosyaadi = res.Data.Dosyaadi;
        this.Dosya = res.Data;

        let ihaleusulu = res.Data.Ihaleturu;

this.ActionsSabitGet(1552).then(res => {
  for (var i = 0; i < res.Data.length; i++) {

    if (ihaleusulu == res.Data[i].Id) {

      this.ihale_usulu = res.Data[i];
    }

  }
});
        this.ActionsGet({ "Service": "Obirim/" + res.Data.Ihaleyiyapanmakam, "Page": this.Page }).then((res2) => {
          this.IdareAdi = res2.Data.BirimAdi;
        });
        this.Teklifdegerlendirmeyontem = res.Data.Teklifdegerlendirmeyontem
        this.Piyasaarastirmagorevliler = res.Data.Piyasaarastirmagorevliler;



        this.ActionsFilterGet({
          Service: "satdosyafirmafiyat/getgiris",
          Page: this.Page,
          Filter:
            "&Dosyaid=" +
            this.satdosyaId +
            "&Asc=Sirano&Fiyatturu=2&TeklifDegerlendirmeYontem=" + this.Teklifdegerlendirmeyontem,
        }).then((res) => {
          this.TableData = res.Data
          this.Firmalar = this.groupBy(res.Data, "Dosyafirmaid");
          this.Malzeme = this.groupBy(res.Data, "Dosyamalzemeid");
          this.FiyatSayisi = Object.keys(this.Firmalar).length
          this.UygunGorulenFirmalar()
          if (this.Teklifdegerlendirmeyontem == 2) {
            this.FormData = []
            for (let Malzeme in this.Malzeme) {
              var KazananFirma = null
              if (!this.Malzeme[Malzeme][0].Kazananfirmaid) {
                KazananFirma = this.Malzeme[Malzeme][0].Hesaplananfirmaid
              } else {
                KazananFirma = this.Malzeme[Malzeme][0].Kazananfirmaid
              }
              this.FormData.push({
                "Id": Malzeme,
                "Dosyaid": this.satdosyaId,
                "Malzemeid": this.Malzeme[Malzeme][0].Malzemeid,
                "Kazananfirmaid": KazananFirma,
              })
            }

          } else {

            for (let Firma in this.Firmalar) {
              if (!this.Firmalar[Firma][0].Kazananfirmaid) {
                this.ToplamkazananFirma = this.Firmalar[Firma][0].Hesaplananfirmaid
              } else {
                this.ToplamkazananFirma = this.Firmalar[Firma][0].Kazananfirmaid
              }

            }

          }

          this.EnDusukFirma()
        });
      });
    },
    UygunGorulenFirmalar() {
      this.ActionsFilterGet({
        Service: "satdosya/GetUygunGorulenFirmalar",
        Page: this.Page,
        Filter: "&Desc=Sirano&Dosyaid=" + this.satdosyaId
      }).then((res) => {
        if (res && Object.keys(res.Data).length > 0) {
          this.UygunGorulenFirmalarData = this.groupBy(res.Data, "Firmaadi");
        }
      })
    },
    FirmaFiyatToplam(firmalar) {
      var ToplamFiyat = 0
      var Birimfiyat = 0
      var Adet = 0
      for (let i = 0; i < firmalar.length; i++) {
        Birimfiyat = firmalar[i].Birimfiyat;
        Adet = firmalar[i].Adet;
        if (Birimfiyat != null) ToplamFiyat += Adet * Birimfiyat
      }
      return ToplamFiyat
    },
    FiyatToplam() {
      var ToplamFiyat = 0
      var Birimfiyat = 0
      var Adet = 0

      for (let firma in this.UygunGorulenFirmalarData) {
        var firmalarmalzeme = this.UygunGorulenFirmalarData[firma]
        for (let i = 0; i < firmalarmalzeme.length; i++) {
          Birimfiyat = firmalarmalzeme[i].Birimfiyat;
          Adet = firmalarmalzeme[i].Adet;
          if (Birimfiyat != null) ToplamFiyat += Adet * Birimfiyat
        }
      }
      return ToplamFiyat
    },
    KazananFirmaBelirle() {
      if (this.Teklifdegerlendirmeyontem == 2) {
        this.UpdateList("satdosyamalzeme/putlistkazananfirma", this.FormData).then((res) => {
          if (res) {
            this.UygunGorulenFirmalar()
          }
        })
      } else {
        var FormData = []
        for (let Malzeme in this.Malzeme) {
          FormData.push({
            "Id": Malzeme,
            "Dosyaid": this.satdosyaId,
            "Malzemeid": this.Malzeme[Malzeme][0].Malzemeid,
            "Kazananfirmaid": this.ToplamkazananFirma,
          })
        }
        this.UpdateList("satdosyamalzeme/putlistkazananfirma", FormData).then((res) => {
          if (res) {
            this.UygunGorulenFirmalar()
          }
        })

      }

    },
    groupBy: function (array, key) {
      const result = {};
      array.forEach((item) => {
        if (!result[item[key]]) {
          result[item[key]] = [];
        }
        result[item[key]].push(item);
      });
      return result;
    },
    FirmaToplamFiyat(FirmaId) {
      var ToplamFiyat = 0;
      var Birimfiyat = 0;
      for (let i = 0; i < this.Firmalar[FirmaId].length; i++) {
        Birimfiyat = this.Firmalar.[FirmaId][i].Birimfiyat;
        if (Birimfiyat != null) ToplamFiyat += Birimfiyat
      }
      return ToplamFiyat.toFixed(2);

    },
    BirimFiyatxMiktarTotal(FirmaId) {
      var ToplamFiyat = 0;
      var Birimfiyat = 0;
      var Adet = 0;

      for (let i = 0; i < this.Firmalar[FirmaId].length; i++) {
        Birimfiyat = this.Firmalar.[FirmaId][i].Birimfiyat;
        Adet = this.Firmalar.[FirmaId][i].Adet;
        if (Birimfiyat != null) ToplamFiyat += Birimfiyat * Adet
      }
      return ToplamFiyat.toFixed(2);

    },
    FirmaToplamFiyatTotal(FirmaId) {
      var ToplamFiyat = 0;
      var Birimfiyat = 0;

      for (let i = 0; i < this.Firmalar[FirmaId].length; i++) {
        Birimfiyat = this.Firmalar.[FirmaId][i].Birimfiyat;
        if (Birimfiyat != null) ToplamFiyat += Birimfiyat
      }
      return ToplamFiyat.toFixed(2);

    },

    ExcelExport(table, name) {
      this.checkboxdisapled = false
      setTimeout(function () {
        if (!table.nodeType) table = this.$refs.PiyasaArastirmaTutanagi
        var html = table.innerHTML
        var ctx = { worksheet: name || 'Worksheet', table: html }
        var a = document.createElement('a');
        a.href = this.uri + this.base64(this.format(this.template, ctx));
        a.download = name + '.xls';
        a.click();
        this.checkboxdisapled = true
      }.bind(this), 100);
    },
    Export2Word(element, filename) {
      this.checkboxdisapled = false
      setTimeout(function () {
        var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
        var postHtml = "</body></html>";
        var html = preHtml + document.getElementById(element).innerHTML + postHtml;

        var blob = new Blob(['\ufeff', html], {
          type: 'application/msword'
        });
        // Specify link url
        var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);

        // Specify file name
        filename = filename ? filename + '.doc' : 'document.doc';

        // Create download link element
        var downloadLink = document.createElement("a");

        document.body.appendChild(downloadLink);

        if (navigator.msSaveOrOpenBlob) {
          navigator.msSaveOrOpenBlob(blob, filename);
        } else {
          // Create a link to the file
          downloadLink.href = url;

          // Setting the file name
          downloadLink.download = filename;

          //triggering the function
          downloadLink.click();
        }

        document.body.removeChild(downloadLink);

        this.checkboxdisapled = true
      }.bind(this), 100);

    },

    EnDusukFirma() {
      var DusukTutar = 0;
      for (let Firma in this.Firmalar) {
        let FirmaToplamSorgu = this.FirmaToplamFiyat(this.Firmalar[Firma][0].Dosyafirmaid)
        if (DusukTutar > FirmaToplamSorgu || DusukTutar == 0) {
          this.EnDusukFirmaToplam = FirmaToplamSorgu
        }
      }
    },
    generateReport() {
      this.$refs.piyasafiyat.generatePdf();
    },
    MalzemeEnDusukFirmaId(MalzemeId, FirmaId) {
      if (this.Teklifdegerlendirmeyontem == 2) {
        var minfiyat = 0
        var firmamalzemefiyat = 0
        for (let i = 0; i < this.Malzeme[MalzemeId].length; i++) {
          if (minfiyat > this.Malzeme[MalzemeId][i].Birimfiyat || minfiyat == 0) {
            minfiyat = this.Malzeme[MalzemeId][i].Birimfiyat
          }
          if (this.Malzeme[MalzemeId][i].Dosyafirmaid == FirmaId) {
            firmamalzemefiyat = this.Malzeme[MalzemeId][i].Birimfiyat
          }
        }
        if (firmamalzemefiyat == minfiyat) {
          return true
        }
        else return false
      }
      else return false
    }

  },

};
</script>
<template>
  <Loader>
    <b-modal id="piyasaarastirmatutanagi" size="xl" scrollable :title="$t('piyasaarastirmatutanagi.Title')"
      title-class="font-18" hide-footer>

      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4">
                  <button type="button" class="btn btn-primary btn-rounded mb-2 me-2" @click="KazananFirmaBelirle()"
                    v-if="!Tamamlandi">
                    {{ $t("piyasaarastirmatutanagi.Page.fiyatlarikaydet") }}
                  </button>
                </div>
                <div class="col-sm-8">
                  <div class="text-sm-end">
                    <button type="button" class="btn btn-success btn-rounded mb-2 me-2" @click="
                      ExcelExport(
                        'Teklif Fiyat Değerlendirme',
                        'Teklif Fiyat Değerlendirme'
                      )
                      ">
                      <i class="mdi mdi-file-export-outline me-1"></i>
                      {{ $t("piyasaarastirmatutanagi.Page.ExceleAktar") }}
                    </button>
                    <button type="button" class="btn btn-warning btn-rounded mb-2 me-2" @click="
                      Export2Word(
                        'exportContent',
                        'Teklif Fiyat Değerlendirme'
                      )
                      ">
                      <i class="mdi mdi-file-export-outline me-1"></i>
                      Word'e Aktar
                    </button>
                    <button type="button" class="btn btn-warning btn-rounded me-5 mb-2" @click="generateReport()">
                      <i class="mdi mdi-file-export-outline me-1"></i>
                      PDF
                    </button>
                  </div>
                </div>
                
              </div>
              <VueHtml2pdf :show-layout="true" :float-layout="false" :enable-download="false" :preview-modal="true"
                :paginate-elements-by-height="1400" filename="Ozgecmis" :pdf-quality="1" :manual-pagination="false"
                pdf-format="a2" pdf-orientation="portrait" pdf-content-width="100%" ref="piyasafiyat">
                <section slot="pdf-content">
                  <div id="exportContent">
                    <div class="row">
                      <div class="col-md-12" style="margin-left: 5px; margin-right: 5px; margin-top: 5px;">
                        <div class="a4_yatay" >
                          <div id="exportContent">
                            <div class="table-responsive" style="border: 1px solid">
                              <table style="width: 100%" class="table table-borderless mb-0"
                                ref="PiyasaArastirmaTutanagi">
                                <thead>
                                  <tr>
                                    <td colspan="2" class="text-sm-center">
                                      <i style="color: #323748" class="fa fa-mouse-pointer"></i>        PİYASA FİYAT ARAŞTIRMA TUTANAĞI
                                    </td>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td colspan="2"></td>
                                  </tr>
                                  <tr>
                                    <th scope="row" style="text-align: left">
                                      İdarenin Adı: {{ IdareAdi }}
                                    </th>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <th scope="row" style="text-align: left">
                                      Yapılan İş / Mal / Hizmetin Adı, Niteliği:
                                    </th>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <th scope="row" style="text-align: left">
                                      Alım ve Yetkilendirilen Görevlilere İlişkin Onay
                                      Belgesi /Görevlendirme Onayı Tarih ve No.su:
                                    </th>
                                    <td></td>
                                  </tr>
                                  <tr v-if="Dosya.Yaklasikmaliyetwebsite == true && Dosya.Yaklasikmaliyetwebsiteilktarih != null">
                                    <th scope="row" style="text-align: left">
                                      İlanın Yayın Tarihi:                 {{ Dosya.Yaklasikmaliyetwebsiteilktarih | formatDateTable}}
                                    </th>
                                    <td>
                      
                                    </td>
                                  </tr>
                                  <tr v-if="Dosya.Yaklasikmaliyetwebsite == true">
                                    <th scope="row" style="text-align: left">
                                      İlanın Yayından Kaldırılma Tarihi:   {{ Dosya.Yaklasikmaliyetwebsitesontarih | formatDateTable }}
                                    </th>
                                    <td>
                                    
                                    </td>
                                  </tr>
                                  <tr>
                                    <td colspan="2"></td>
                                  </tr>
                                  <tr>
                                    <td colspan="2">
                                      <table style="border-collapse: collapse; width: 100%"
                                        class="table table-bordered mb-0">
                                        <tbody>
                                          <tr>
                                            <th rowspan="2" style="text-align: center;border: 1px solid;">
                                              SIRA NO
                                            </th>
                                            <th style="border: 1px solid;" rowspan="2">MAL / HİZMET / YAPIM İŞİ</th>
                                            <th style="border: 1px solid;" rowspan="2">MİKTAR</th>
                                            <th style="border: 1px solid;" rowspan="2">BİRİM</th>
                                            <th style="border: 1px solid;" :colspan="FiyatSayisi">
                                              KİŞİ / FİRMA / FİRMALAR VE FİYAT TEKLİFLERİ
                                            </th>
                                          </tr>
                                          <tr>
                                            <th style="border: 1px solid;" v-for="(Firma, index) in Firmalar"
                                              :key="index">
                                              {{ Firma[0].Firmaadi }}
                                            </th>
                                          </tr>
                                          <tr v-for="(Malzeme, name, index) in Malzeme" :key="index">
                                            <td style="text-align: center;border: 1px solid;">
                                              {{ Malzeme[0].Sirano }}
                                            </td>
                                            <td style="border: 1px solid;">{{ Malzeme[0].Malzemeadi }}</td>
                                            <td style="border: 1px solid;">{{ Malzeme[0].Adet }}</td>
                                            <td style="border: 1px solid;">{{ Malzeme[0].Olcubirimi }}</td>
                                            <template v-for="(Firma, firmaindex) in Firmalar">
                                              <td :key="firmaindex" style="text-align: right;border: 1px solid;">
                                                <div class="row">
                                                  <div class="col-md-4">
                                                    <b-form-checkbox v-if="Teklifdegerlendirmeyontem == 2 &&
                                                      checkboxdisapled
                                                      " :value="Firma[0].Dosyafirmaid" unchecked-value="" :name="index" v-model="FormData[index].Kazananfirmaid
    " :disabled="Firma[0].Kazananfirmaid" class="mb-3"></b-form-checkbox>
                                                  </div>
                                                  <div class="col-md-8">
                                                    {{
                                                      Firma.filter((notification) =>
                                                        notification.Dosyamalzemeid.includes(
                                                          Malzeme[0].Dosyamalzemeid
                                                        )
                                                      )[0].Birimfiyat * Firma.filter((notification) =>
                                                        notification.Dosyamalzemeid.includes(
                                                          Malzeme[0].Dosyamalzemeid
                                                        )
                                                      )[0].Adet | TrParaFormat
                                                    }}
                                                  </div>
                                                </div>
                                              </td>
                                            </template>
                                          </tr>

                                          <tr>
                                            <th colspan="4" style="text-align: right;border: 1px solid;">
                                              TOPLAM :
                                            </th>
                                            <td v-for="(Firma, index) in Firmalar" :key="index"
                                              style="text-align: right;border: 1px solid;">
                                              <div class="row">
                                                <div class="col-md-4">

                                                  <b-form-checkbox v-if="Teklifdegerlendirmeyontem != 2 &&
                                                    checkboxdisapled
                                                    " :value="Firma[0].Dosyafirmaid" unchecked-value="" class="mb-3"
                                                    v-model="ToplamkazananFirma"
                                                    :disabled="Firma[0].Kazananfirmaid"></b-form-checkbox>
                                                </div>
                                                <div class="col-md-8 text-sm-end">
                                                  {{
                                                    BirimFiyatxMiktarTotal(Firma[0].Dosyafirmaid)
                                                  }}
                                                </div>
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>


                                        <tbody>
                                          <tr>
                                            <td colspan="2"></td>
                                          </tr>
                                          <tr>
                                            <td colspan="6" style="border-bottom: 1px solid;"></td>
                                          </tr>
                                          <tr>
                                            <th rowspan="2" style="text-align: center;border: 1px solid !important;">
                                              SIRA NO
                                            </th>
                                            <th style="border: 1px solid;" rowspan="2">MAL / HİZMET / YAPIM İŞİ</th>
                                            <th style="border: 1px solid;" rowspan="2">MİKTAR</th>
                                            <th style="border: 1px solid;" rowspan="2">BİRİM</th>
                                            <th style="border: 1px solid;" :colspan="FiyatSayisi + 1">
                                              UYGUN GÖRÜLEN KİŞİ / FİRMA / FİRMALAR
                                            </th>
                                          </tr>
                                          <tr>
                                            <th style="border: 1px solid;">
                                              ADI
                                            </th>
                                            <th style="border: 1px solid;">
                                              ADRESİ
                                            </th>
                                            <th style="border: 1px solid;">
                                              TEKLİF ETTİĞİ FİYAT
                                            </th>
                                          </tr>
                                          <template v-for="(Firmalar) in UygunGorulenFirmalarData">
                                            <template v-for="(FirmaMalze, index) in Firmalar">
                                              <tr :key="index">
                                                <td style="border: 1px solid;">{{ FirmaMalze.Sirano }}</td>
                                                <td style="border: 1px solid;">{{ FirmaMalze.Adi }}</td>
                                                <td style="border: 1px solid;">{{ FirmaMalze.Adet }}</td>
                                                <td style="border: 1px solid;">{{ FirmaMalze.Olcubirimi }}</td>
                                                <td style="border: 1px solid;">{{ FirmaMalze.Firmaadi }}</td>
                                                <td style="border: 1px solid;">{{ FirmaMalze.Firmaadresi }}</td>
                                                <td style="border: 1px solid;">{{ FirmaMalze.Adet * FirmaMalze.Birimfiyat
                                                  | TrParaFormat }}</td>

                                              </tr>
                                              <tr :key="index" v-if="(index + 1) == Firmalar.length">
                                                <th colspan="7" style="text-align: right;border: 1px solid;">
                                                  Firma Toplamı : {{ FirmaFiyatToplam(Firmalar) | TrParaFormat }}
                                                </th>
                                              </tr>
                                            </template>
                                          </template>

                                          <tr>
                                            <th colspan="6" style="text-align: right;border: 1px solid;">
                                              Toplam
                                            </th>
                                            <th style="text-align: right;border: 1px solid;">
                                              {{ FiyatToplam() | TrParaFormat }}
                                            </th>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td colspan="2"></td>
                                  </tr>




                                  <tr>
                                    <td colspan="2"></td>
                                  </tr>


                                  <tr>
                                    <td colspan="2">
                                      <table class="table table-borderless mb-0" style="border-collapse: collapse;">
                                        <thead>
                                          <tr>
                                            <td :colspan="4 + FiyatSayisi <
                                                Personeller.length
                                                ? Personeller.length
                                                : 4 + FiyatSayisi 
                                              ">
                                              <p></p>
                                              4734 sayılı Kamu İhale Kanunu'nun <span> {{ ihale_usulu.Value }} Maddesi uyarınca doğrudan temin usulüyle</span> 
                                              
                                              yapılacak alımlara ilişkin yapılan piyasa
                                              araştırmasında kişi / firmalarca teklif edilen
                                              fiyatlar tarafımca / tarafımızca
                                              değerlendirilerek yukarıda adı ve adresleri
                                              belirtilen kişi / firma / firmalardan alım
                                              yapılması uygun görülmüştür. Tarih: ..../..../........
                                              <p></p>
                                            </td>
                                          </tr>
                                          <tr>
                                            <th :colspan="4 + FiyatSayisi <
                                                Personeller.length
                                                ? Personeller.length
                                                : 4 + FiyatSayisi
                                              " style="text-align: center">
                                              Piyasa Fiyat Araştırması Görevlisi /
                                              Görevlileri
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td style="border: 1px solid;" v-for="(
                                      Gorevliler, index
                                    ) in this.Personeller" :key="index">
                                              <b>Adı Soyadı:</b> {{ Gorevliler.Adsoyad }}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td style="border: 1px solid;" v-for="(
                                      Gorevliler, index
                                    ) in this.Personeller" :key="index">
                                              <b>Ünvanı:</b> {{ Gorevliler.Unvanadi }}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td style="border: 1px solid;" v-for="(
                                      Gorevliler, index
                                    ) in this.Personeller" :key="index">
                                              <b>İmzası:</b>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>


 
                                <VueQRCodeComponent style="margin: 0 auto;" size="100"
                                  :text='"İşin Adı: " + Dosyaadi + "  DÜZENLENME TARİHİ:" + GununTarihi + " Oluşturan Kullanıcı:" + UserNameSurName' />

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </VueHtml2pdf>
            </div>
          </div>
        </div>
      </div>


    </b-modal>
  </Loader></template>
